import
{
  Container,
  StyledSpinner,
} from './SectionSpinner.styles';

const SectionSpinner = (smaller) =>
{
  let spinnerSize = 40;
  if (smaller)
  {
    spinnerSize = 20;
  }
  return (
    <Container>
      <StyledSpinner size={spinnerSize} />
    </Container>
  );
};

export default SectionSpinner;
